import { createProviderToken } from '@core/common-legacy';

export const { provide: provideTellentAssistantEndpoint, inject: injectTellentAssistantEndpoint } =
  createProviderToken<string>('TELLENT_ASSISTANT_ENDPOINT')(false);

export const {
  provide: provideTellentAssistantAuthTokenGetter,
  inject: injectTellentAssistantAuthTokenGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_AUTH_TOKEN_GETTER')(false);

export const {
  provide: provideTellentAssistantThreadsBaseUrl,
  inject: injectTellentAssistantThreadsBaseUrl,
} = createProviderToken<string>('TELLENT_ASSISTANT_THREADS_BASE_URL')(false);

export const {
  provide: provideTellentAssistantResourceIdGetter,
  inject: injectTellentAssistantResourceIdGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_RESOURCE_ID_GETTER')(false);

export const {
  provide: provideTellentAssistantActorGetter,
  inject: injectTellentAssistantActorGetter,
} = createProviderToken<() => string | null>('TELLENT_ASSISTANT_ACTOR_GETTER')(false);
